const getUuid = (url: string) => {
  const incompleteUuid = url.split('.com/')
  const uuid = incompleteUuid[1].split('?')[0]
  return uuid
}
export default getUuid
